import { observable, action, makeObservable } from 'mobx';
import { UserInfoApis } from '../../../../apis/user_info';
import { PasswordChangeFormState } from './PasswordChangeFormState';

export class PasswordChangePaneState {
  formState: PasswordChangeFormState = new PasswordChangeFormState();
  submitting = false;

  constructor() {
    makeObservable(this, {
      formState: observable,
      submitting: observable,
      submit: action.bound,
    });
  }

  async submit() {
    this.submitting = true;
    try {
      this.formState.clearErrors();
      try {
        await UserInfoApis.updatePassword(this.formState.asJson());
      } catch (error) {
        this.formState.setErrors(error.body);
      }
    } finally {
      this.submitting = false;
    }
  }
}
